import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PERU_LOCATIONS } from './peru-locations';
import { map, shareReplay } from 'rxjs/operators';

export interface Location {
  dep: string;
  prov: string;
  dist: string;
}

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private locations$: Observable<Location[]> | null = null;

  private loadLocations(): Observable<Location[]> {
    if (!this.locations$) {
      this.locations$ = of(PERU_LOCATIONS).pipe(shareReplay(1));
    }
    return this.locations$;
  }

  getDepartments(): Observable<string[]> {
    return this.loadLocations().pipe(
      map(locations => {
        const departments = Array.from(new Set(locations.map(loc => loc.dep)));
        return departments.sort();
      })
    );
  }

  getProvincesByDepartment(department: string): Observable<string[]> {
    return this.loadLocations().pipe(
      map(locations => {
        const provinces = Array.from(new Set(locations.filter(loc => loc.dep === department).map(loc => loc.prov)));
        return provinces.sort();
      })
    );
  }

  getDistrictsByProvince(department: string, province: string): Observable<string[]> {
    return this.loadLocations().pipe(
      map(locations => {
        const districts = locations.filter(loc => loc.dep === department && loc.prov === province).map(loc => loc.dist);
        return districts.sort();
      })
    );
  }
}
